"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFormatter = void 0;

var _Attachment = _interopRequireDefault(require("./Attachment"));

var _Checkbox = _interopRequireDefault(require("./Checkbox"));

var _Collaborator = _interopRequireDefault(require("./Collaborator"));

var _CreatedBy = _interopRequireDefault(require("./CreatedBy"));

var _Currency = _interopRequireDefault(require("./Currency"));

var _Date = _interopRequireDefault(require("./Date"));

var _Duration = _interopRequireDefault(require("./Duration"));

var _LinkToRecord = _interopRequireDefault(require("./LinkToRecord"));

var _Lookup = _interopRequireDefault(require("./Lookup"));

var _MultiSelect = _interopRequireDefault(require("./MultiSelect"));

var _Number = _interopRequireDefault(require("./Number"));

var _Percent = _interopRequireDefault(require("./Percent"));

var _Rating = _interopRequireDefault(require("./Rating"));

var _Selected = _interopRequireDefault(require("./Selected"));

var _SingleSelect = _interopRequireDefault(require("./SingleSelect"));

var _Url = _interopRequireDefault(require("./Url"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var getFormatter = function getFormatter(type) {
  if (type === "selected") {
    return _Selected["default"];
  }

  if (type === "checkBox") {
    return _Checkbox["default"];
  }

  if (type === "singleSelect") {
    return _SingleSelect["default"];
  }

  if (type === "multiSelect") {
    return _MultiSelect["default"];
  }

  if (["date", "createdAt", "updatedAt"].includes(type)) {
    return _Date["default"];
  }

  if (type === "url") {
    return _Url["default"];
  }

  if (type === "percent") {
    return _Percent["default"];
  }

  if (type === "duration") {
    return _Duration["default"];
  }

  if (type === "currency") {
    return _Currency["default"];
  }

  if (type === "linkToRecord") {
    return _LinkToRecord["default"];
  }

  if (type === "number") {
    return _Number["default"];
  }

  if (["createdBy", "updatedBy"].includes(type)) {
    return _CreatedBy["default"];
  }

  if (type === "collaborator") {
    return _Collaborator["default"];
  }

  if (type === "attachment") {
    return _Attachment["default"];
  }

  if (type === "rating") {
    return _Rating["default"];
  }

  if (type === "lookup") {
    return _Lookup["default"];
  }

  return null;
};

exports.getFormatter = getFormatter;